import { useMemo } from 'react';
import metaTagsConstants from '@/creditflowresearch/ui/common/metaTagsConstants';

interface IUseScorecardSeoProps {
  companyName?: string,
}

export const useScorecardSeo = ({ companyName }: IUseScorecardSeoProps) => {
  const { title, description } = useMemo(
    () => metaTagsConstants.underwriterRatingAgency(companyName),
    [companyName],
  );

  return {
    title,
    description,
  };
};
